import React, {useState, useEffect} from 'react'
import moment from 'moment';
import axios from '../../../plugins/axios'
import StripWave from './stripWave';
import { useTranslation } from 'react-i18next'

//여기서 데이터를 받아서
const Strip = ({deviceInfo,startTime,endTime,selectTime,wave1,wave2}) => {
    const { t } = useTranslation()
    const [stripData, setStripData] = useState(null);

    const getStripData = async () => {
        try {
            const totalWave = [];
            const waves = [wave1, wave2];

            for (const wave of waves) {                
                const waveRes = await axios.get(`/trend/waveforms?serialNo=${deviceInfo?.serial}&type=${wave}&startTime=${moment.utc(selectTime).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(selectTime).add(30, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);
                const fillwave = setTrendWaveList(
                    waveRes.data.waveformData.waveforms,
                    wave,
                    moment.utc(selectTime).format('YYYY-MM-DDTHH:mm:ss'),
                    moment.utc(selectTime).add(30, 'seconds').format('YYYY-MM-DDTHH:mm:ss')
                );                

                if (Array.isArray(fillwave)) {
                    fillwave.forEach((batch) => {
                        totalWave.push(batch);
                    });
                }
            }

            setStripData(totalWave);
            
        } catch (err) {
            console.warn(err);
        }
    }

    // Trend Wave 빈 데이터 생성 및 추가.
        const setTrendWaveList = (data,trendWaveType, startTime, endTime) => {
            // 시작 시간과 끝 시간을 moment로 변환
            const start = moment.utc(startTime).startOf("second");
            const end = moment.utc(endTime).startOf("second");       
        
            // 시작 시간부터 끝 시간까지 초 단위로 빈 데이터 생성
            const allSeconds = [];
            let current = start.clone();
            while (current < end) {
                allSeconds.push(current.format());
                current.add(1, "second");
            }
        
            // 실제 데이터를 Timestamp : value 형태로 변환
            const groupedBySecond = data.reduce((acc, item) => {
                const secondKey = moment.utc(item.timestamp).startOf("second").format();  
                acc[secondKey] = item.samples || [];
                return acc;
            }, {});           
    
            const completeResult = allSeconds
            .map((second) => ({
                type : trendWaveType,
                createdAt: second,
                wave: groupedBySecond[second] || [], // 데이터가 없으면 빈 배열
            }))
            .reduce((batches, item, index) => {
                const batchIndex = Math.floor(index / 10);
                if (!batches[batchIndex]) {
                    batches[batchIndex] = [];
                }
                batches[batchIndex].push(item);
                return batches;
            }, []);
    
            return completeResult;
        };

    useEffect(() => {
        getStripData();
    }, [deviceInfo])    

    const titleFontBold = 'text-black font-medium text-[48px] leading-[110%] font-pretendard';
    const stripWaveFont = 'text-black font-medium text-[40px] leading-[120%] font-pretendard';

    return (
        <div className="a4-page-landscape mx-auto bg-white shadow-lg relative box-border">
            <div className="w-full h-full flex flex-col px-[146px] pt-[140px] pb-[66px]">                
                {/* Header */}
                <div className="w-full flex items-center justify-start pb-[24px] border-b-[4px] border-[#5E5E5E]">
                    <div className="flex items-center justify-center gap-[20px]">
                        <strong className={titleFontBold}>
                            {t("print.trendForm.strip")}
                        </strong>                        
                    </div>
                </div>    

                {/* Content */}
                <div className="w-full relative mb-[30px]">
                    {
                        stripData && 
                        [wave1, wave2].map((wave, index) => {
                            return (
                                <div className='relative w-full mt-[30px]' key={wave + index}>                                
                                    <div className='absolute left-[12px] top-0 w-full'>
                                        <strong className={stripWaveFont}>{wave}</strong>
                                    </div>
                                    <div>
                                        {
                                            stripData.filter(item => item[0]?.type === wave).map((data,idx) => {
                                                return (                                                
                                                    <StripWave data={data} waveType={wave}/>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )                    
                        })
                    }
                </div>

                {/* Footer */}
                <div className="w-full flex items-center justify-end">
                    <div>
                        <span className="text-black text-center font-pretendard text-[24px] font-medium leading-[110%]">
                            (2/2)
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Strip